// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__2jNSU","loader":"Spinner_loader__Wk2G-","round":"Spinner_round__3yi3L"};